export class UploadFilesData {
  public object: any;

  constructor(
    public fileName: string,
    public loadedSize: number, // between 0-100. 100 == upload finish
  ) {
  }
}
